import ReactGA from "react-ga";

export const CLICK_TV = "CLICK_TV";
export const CLICK_RADIO = "CLICK_RADIO";

/**
 * Event - Add custom tracking event.
 * @param {string} category
 * @param {string} action
 * @param {string} label
 */
export const Event = (category, action, label) => {
  ReactGA.event({
    category: category,
    action: action,
    label: label,
  });
};
